import React, { useEffect, useState } from "react";
import _ from "lodash";
import { Button, FormLayout, Heading, Input } from "@/ui";
import { useForm, useValidator } from "@/hooks";
import styles from "./SwifterForm.module.scss";

const fieldError = (validator, name) =>
    validator?.[name]?.isInvalid ? validator[name].message : undefined;

const AccountDutchieForm = ({
    isCreate,
    handleCancel,
    app,
    selectCredential,
    setCredentials,
    isUpdating,
    handlerUpdatingOrCreate,
}) => {
    const [isFormReset, resetFormInputs] = useState(isCreate);
    const { inputs, inputChange, setInputs } = useForm();

    const { validator, isValid, isSubmited } = useValidator(
        [
            {
                field: "api_key",
                method: "isEmpty",
                validWhen: false,
                message: "This Api key is required.",
            },
            {
                field: "secret_api_key",
                method: "isEmpty",
                validWhen: false,
                message: "This Secret Api Key is required.",
            },
            {
                field: "retailer_id",
                method: "isEmpty",
                validWhen: false,
                message: "This Retailer Id is required.",
            },
            {
                field: "store_name",
                method: "isEmpty",
                validWhen: false,
                message: "This Store Name is required.",
            },
        ],
        {
            ...inputs,
        },
    );

    useEffect(() => {
        if (!isCreate) {
            const objSelect = app?.credentials[selectCredential];
            setInputs({
                api_key: objSelect?.api_key,
                secret_api_key: objSelect?.secret_api_key,
                retailer_id: objSelect?.retailer_id,
                store_name: objSelect?.store_name,
            });
        }
    }, []);

    if (!isCreate && !isFormReset) {
        resetFormInputs(true);
    }

    const createOrUpdate = async () => {
        if (isSubmited) {
            isSubmited(true);
        }

        if (isValid()) {
            let accounts = _.cloneDeep(app.credentials);

            if (isCreate) {
                accounts.push({
                    api_key: inputs?.api_key,
                    secret_api_key: inputs?.secret_api_key,
                    retailer_id: inputs?.retailer_id,
                    store_name: inputs?.store_name,
                });
            } else {
                accounts[selectCredential] = inputs;
            }
            setCredentials(accounts);
            handlerUpdatingOrCreate(accounts);
        }
    };

    const handleClose = () => {
        handleCancel();
        resetFormInputs(false);
    };

    return (
        <div className={styles.credentialForm}>
            <Heading level={5}>
                {isCreate ? "Add Credential" : "Update Credential"}
            </Heading>

            <FormLayout>
                <FormLayout.Section>
                    <FormLayout.Grid columns={2} maxWidth="twoThirds">
                        <Input
                            error={fieldError(validator, "store_name")}
                            fullWidth
                            label="Store Name"
                            name="store_name"
                            onChange={inputChange}
                            placeholder="Store Name"
                            value={inputs.store_name || ""}
                        />
                        <Input
                            error={fieldError(validator, "api_key")}
                            fullWidth
                            label="Api Key"
                            name="api_key"
                            onChange={inputChange}
                            placeholder="Api key"
                            value={inputs.api_key || ""}
                        />
                        <Input
                            error={fieldError(validator, "secret_api_key")}
                            fullWidth
                            label="Secret Api Key"
                            name="secret_api_key"
                            onChange={inputChange}
                            placeholder="Secret api key"
                            value={inputs.secret_api_key || ""}
                        />
                        <Input
                            error={fieldError(validator, "retailer_id")}
                            fullWidth
                            label="Retailer Id"
                            name="retailer_id"
                            onChange={inputChange}
                            placeholder="Retailer id"
                            value={inputs.retailer_id || ""}
                        />
                    </FormLayout.Grid>
                </FormLayout.Section>
            </FormLayout>

            <div className={styles.credentialActions}>
                <Button
                    disabled={isUpdating}
                    onClick={handleClose}
                    type="button"
                    variant="secondary"
                >
                    Cancel
                </Button>
                <Button
                    loading={isUpdating}
                    onClick={createOrUpdate}
                    type="button"
                >
                    Save
                </Button>
            </div>
        </div>
    );
};

export default AccountDutchieForm;
